module.exports = __webpack_public_path__ + "media/promo/panasonic/images/logo-9d74bafd8e079104d2707097b2068e12.svg";